(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/hooks/use-get-exclusions.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/hooks/use-get-exclusions.js');
'use strict';

const {
  useState,
  useEffect
} = React;
const useGetExclusions = (exclusions, isNaExcluded) => {
  const [hasExclusions, setHasExclusions] = useState(false);
  useEffect(() => {
    setHasExclusions(exclusions.length > 0 || isNaExcluded);
  }, [exclusions, isNaExcluded]);
  return hasExclusions;
};
svs.selfExclusion.useGetExclusions = useGetExclusions;

 })(window);